import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { withRouter } from 'react-router'

import SignUpComponent from '../components/login/SignUp/SignUpComponent'

import { checkForOtherFields } from './CompanyFormContainer'
import { register, registerEmail } from '../store/actions/session'
import { LANDING_PATH } from '../constants/routes'

const selector = formValueSelector('signUp')
const currentMapStateToProps = (state, { history, location }) => ({
    history,
    location,
    ...checkForOtherFields(state, selector, history),
})

const mapDispatchToProps = {
    register,
    registerEmail,
}

const mergeProps = ({ history, location, ...state }, { register, registerEmail }) => {
    return {
        ...state,
        location,
        onCancel: () => {
            const { state } = location
            let path = LANDING_PATH

            if (state && state.prevPath) {
                path = state.prevPath
            }

            history.push(path)
        },
        onSubmit: register,
        onValidateEmail: registerEmail,
    };
};

export default withRouter(connect(currentMapStateToProps, mapDispatchToProps, mergeProps)(SignUpComponent));



// WEBPACK FOOTER //
// ./src/containers/SignUpContainer.js